import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useCources from "../../../../hooks/useCources";

const SingleCourseDetails = () => {
  const {courseID}=useParams()
 
  return (
    <>
      <div className="container">
        <h1>Single Course Id {courseID}</h1>
      </div>
    </>
  );
};

export default SingleCourseDetails;
